import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const TRELLO_API_KEY = "976ff84fd483e371bff82da266f31a35";
const TRELLO_TOKEN =
  "ATTA30c4de8bbd4d03f91d2759238921a25352ddcfaf8f030c1a2029d23407e4b7de0E8743AF";
const BOARD_ID = "697ab07aa257c66a14d1cad9"; // Office Kanban

const initialState = {
  lists: [],
  cards: [],
  isLoading: false,
  error: null,
  lastUpdated: null,
};

export const fetchTrelloBoard = createAsyncThunk(
  "trello/fetchBoard",
  async (_, { rejectWithValue }) => {
    try {
      const [listsRes, cardsRes] = await Promise.all([
        fetch(
          `https://api.trello.com/1/boards/${BOARD_ID}/lists?key=${TRELLO_API_KEY}&token=${TRELLO_TOKEN}`
        ),
        fetch(
          `https://api.trello.com/1/boards/${BOARD_ID}/cards?key=${TRELLO_API_KEY}&token=${TRELLO_TOKEN}&fields=name,desc,idList,due,labels,dateLastActivity,idMembers`
        ),
      ]);

      if (!listsRes.ok || !cardsRes.ok) {
        throw new Error("Failed to fetch Trello data");
      }

      const lists = await listsRes.json();
      const cards = await cardsRes.json();

      return { lists, cards };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const trelloSlice = createSlice({
  name: "trello",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrelloBoard.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTrelloBoard.fulfilled, (state, action) => {
        state.isLoading = false;
        state.lists = action.payload.lists;
        state.cards = action.payload.cards;
        state.lastUpdated = new Date().toISOString();
      })
      .addCase(fetchTrelloBoard.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = trelloSlice.actions;
export default trelloSlice.reducer;
